module.exports = __webpack_public_path__ + "static/img/login-list-icon-apple.f001cd6f.svg";